import {
  Box,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import React from "react";
import MapIcon from "@mui/icons-material/Map";
import ListAltIcon from "@mui/icons-material/ListAlt";
import DownloadIcon from "@mui/icons-material/Download";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import LogoutIcon from "@mui/icons-material/Logout";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import { Link } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

interface ListItemLinkProps {
  icon?: React.ReactElement<unknown>;
  primary: string;
  to: string;
}

function ListItemLink(props: ListItemLinkProps) {
  const { icon, primary, to } = props;

  return (
    <ListItemButton component={Link} to={to}>
      {icon ? <ListItemIcon>{icon}</ListItemIcon> : null}
      <ListItemText primary={primary} />
    </ListItemButton>
  );
}

interface NavigationProp {
  toggleDrawer: (
    open: boolean
  ) => (event: React.KeyboardEvent | React.MouseEvent) => void;
}

const Navigation = ({ toggleDrawer }: NavigationProp) => {
  const auth = useAuth0();

  return (
    <Box
      sx={{ width: 250 }}
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <List>
        <ListItem disablePadding>
          <ListItemLink to="/" primary="Carte" icon={<MapIcon />} />
        </ListItem>
        <ListItem disablePadding>
          <ListItemLink
            to="/persos"
            primary="Liste d'Habitants"
            icon={<ListAltIcon />}
          />
        </ListItem>
        <ListItem disablePadding>
          <ListItemLink
            to="/importation"
            primary="Importation"
            icon={<DownloadIcon />}
          />
        </ListItem>
        <ListItem disablePadding>
          <ListItemLink
            to="/presences"
            primary="Presences"
            icon={<PersonSearchIcon />}
          />
        </ListItem>
        <ListItem disablePadding>
          <ListItemLink to="/cryo" primary="Cryogénie" icon={<AcUnitIcon />} />
        </ListItem>
        <ListItem disablePadding>
          <ListItemLink
            to="/finder"
            primary="Ajouts d'Habitants"
            icon={<PersonAddIcon />}
          />
        </ListItem>
        <ListItemButton
          onClick={async () => {
            await auth.logout();
          }}
          key="logout"
        >
          <ListItemIcon>
            <IconButton>
              <LogoutIcon />
            </IconButton>
          </ListItemIcon>
          <ListItemText primary="Déconnexion" />
        </ListItemButton>
      </List>
    </Box>
  );
};

export default Navigation;
